import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import MultiSelectReact from 'react-multi-select-ext';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';

  
const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000' 
};


let selectAll = true
export default class SectionDropDown extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
          sectionListArray: [],
          selectedSectionIDs:-1,
          loading: true,
        };
      }

      
    //Loads All Sections for a given course on Component Mount
    componentWillMount() {
        console.debug("archive mode section ",this.props.archiveMode , this.props.sectionMap)
        if(!this.props.selectAll){
            selectAll = false
        }
        if(this.props.archiveMode && this.props.sectionMap){
            let sectionArray = [];
            if(this.props.perfDataMode !== true){
                sectionArray =   this.props.sectionMap[this.props.selectedCourseID].map(
                    this.makeSectionlistArrayArchive
                    );
            }else{
                sectionArray = sectionArray =   this.props.sectionMap.map(
                    this.makeSectionlistArray
                    );
            }
            

            this.setState({sectionListArray:sectionArray,loading: false},()=>{
                this.props.onChange(sectionArray);
            });
        }
        else 
            this.updateSections(this.props.selectedCourseID);
    }

    componentWillReceiveProps(nextProps)
    {
        
        if(this.props.selectedCourseID !== nextProps.selectedCourseID)
        {
            if(this.props.archiveMode && this.props.sectionMap && this.props.perfDataMode !== true){

                let sectionArray = [];
                if(this.props.perfDataMode !== true){
                    sectionArray =   this.props.sectionMap[nextProps.selectedCourseID].map(
                        this.makeSectionlistArrayArchive
                        );
                }else{
                    sectionArray = sectionArray =   this.props.sectionMap.map(
                        this.makeSectionlistArray
                        );
                }
                this.setState({sectionListArray:sectionArray,loading: false},()=>{
                    this.props.onChange(sectionArray);
                });
            }
            else    
                this.updateSections(nextProps.selectedCourseID);
            
        }
    }
    //Update Sections
    updateSections = (selectedCourseID) => 
    {
        if(selectedCourseID <= 0)
            return;
            
        let parent = this;
        let sectionListPromise =   this.getSectionData(selectedCourseID);
         sectionListPromise.then(sectionList => {
            if(sectionList.length > 0 )
            {
                let sectionArray    =   sectionList.map(
                    this.makeSectionlistArray
                    );
                parent.setState({sectionListArray:sectionArray,loading: false},()=>{
                    parent.props.onChange(sectionArray);
                });
            }else{
                //NotificationManager.error('ERROR','Selected Course hase No Section. Please Select a differetn Course.');
                parent.setState({loading:false})
            }
            
        }).catch(error => {
            console.error("error retriving sections ",error);
            this.setState({loading:false});
            NotificationManager.error(error,"Error - Empty Response",5000);
        })
    }
    //Create an Array of SectionList for Select Box
    makeSectionlistArray(sectionObj, index) {
        return {
            index: sectionObj.section_id,
            label: sectionObj.section_name,
            value: selectAll,
            id:sectionObj.section_id
        };
    }

    makeSectionlistArrayArchive(sectionObj, index) {
        
        return {
            index: sectionObj.value,
            label: sectionObj.label,
            value: true,
            id:sectionObj.value
        };
    }
    

    getSectionData = (req_course_id) => {
        const payload = { course_id: req_course_id,archiveMode:this.props.archiveMode,semesterID:this.props.selectedSemesterID };
    
        return new Promise(function(resolve, reject) {
          ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: payload
          })
            .then(res => {
              if (
                res.data.data.section_names !== null &&
                res.data.data.section_names !== undefined &&
                res.data.data.section_names.length > 0
              ) {
                return resolve(res.data.data.section_names);
              } else {
                console.log('Section Data Empty');
                NotificationManager.error("Section Data Empty",5000);
                let emptyArray = [];
                return resolve(emptyArray);
              }
            })
            .catch(error => {
              console.error('Error When Retriving Section Details ', error);
              reject(error, null);
            });
        });
      }
    //Memoize Function to stop hitting Go Server on Every Request
    //getSectionData = iMemoized.memoize(this.getSectionData);
    
    onSectionChange = (
        argSelectedSectionIDs) => {    
        this.setState({
          selectedSectionIDs: argSelectedSectionIDs,
        });
        if(this.props.onChange !== undefined && this.props.onChange !== null)
            this.props.onChange(argSelectedSectionIDs);
    };

    render(){

        if(this.props.QuizCreation && this.props.sectionArray.length > 0){
            this.setState({sectionListArray:this.props.sectionArray,loading: false},()=>{
                this.props.onChange(this.props.sectionArray);
            });
        }

        if(this.state.loading && !this.props.NoLoader)
        {
            return <LoadingSpinner loading={this.state.loading} />
        }
        if(this.state.sectionListArray && this.state.sectionListArray.length > 0){
            return <MultiSelectReact
                options={this.state.sectionListArray}
                optionClicked={this.onSectionChange}
                selectedBadgeClicked={this.onSectionChange}
                selectedOptionsStyles={selectedOptionsStyles}
                optionsListStyles={optionsListStyles}
                enableSelectAllNone={true}
            
            />
        }else{
            return <p>No Sections Found</p>;
        }
        

    }
}

SectionDropDown.propTypes = {
    onChange: PropTypes.func,
    className:PropTypes.string,
    placeholder:PropTypes.string,
    selectBoxID:PropTypes.string.isRequired,
    archiveMode:PropTypes.bool
    };